export const RECURRENCE_TYPE_VALUES = {
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY_BY_WEEKDAY: 'MonthlyByWeekday',
  MONTHLY_BY_DATE: 'MonthlyByDate',
};

// Base recurrence types for the main dropdown (without duplicates)
export const RECURRENCE_TYPES = [
  { value: RECURRENCE_TYPE_VALUES.DAILY, label: 'day' },
  { value: RECURRENCE_TYPE_VALUES.WEEKLY, label: 'week' },
  { value: RECURRENCE_TYPE_VALUES.MONTHLY_BY_DATE, label: 'month' }, // Default to by-date
];

// Weekdays for recurrence selection
export const WEEKDAYS = [
  { label: 'S', value: '0' },
  { label: 'M', value: '1' },
  { label: 'T', value: '2' },
  { label: 'W', value: '3' },
  { label: 'T', value: '4' },
  { label: 'F', value: '5' },
  { label: 'S', value: '6' },
];

export const PICKUP_TYPE_HOME = 'HOME';
export const PICKUP_TYPE_DOCTOR = 'DOCTOR';
export const PICKUP_DATEPICKER_LABEL = 'Pickup Time';
export const APPOINTMENT_DATEPICKER_LABEL = 'Appointment Time';
export const RETURN_TRIP_PICKUP_DATEPICKER_LABEL = 'Return Trip Pickup Time';
export const TRANSPORT_TIME_ZONE_ID = 'Eastern Standard Time';

export const FIELDS = {
  FACILITY_ID: 'FacilityId',
  RESIDENT_IDS: 'ResidentIds',
  HAS_EXISTING_APPOINTMENT: 'HasExistingAppointment',
  PICKUP_TIME: 'PickupTime',
  RETURN_TRIP_PICKUP_TIME: 'ReturnTripPickupTime',
  APPOINTMENT_DATE_TIME: 'AppointmentDateTime',
  PICKUP_TIME_ORIGINAL: 'PickupTimeOriginal',
  APPOINTMENT_DATE_TIME_ORIGINAL: 'AppointmentDateTimeOriginal',
  SEEN_BY_DATE: 'SeenByDate',
  CREATE_RETURN_TRIP: 'CreateReturnTrip',
  AIDE_REQUIRED: 'AideRequired',
  UNIT_AIDE_REQUIRED: 'UnitAideRequired',
  CNA_REQUIRED: 'CNARequired',
  PCS_FORM: 'PCSForm',
  DETAIL_O2: 'DetailO2',
  DETAIL_SNACK: 'DetailSnack',
  DETAIL_LUNCH: 'DetailLunch',
  DETAIL_XRAYS: 'DetailXrays',
  DETAIL_RESIDENT_DOCUMENTS: 'DetailResidentDocuments',
  DETAIL_CUSHION: 'DetailCushion',
  DETAIL_HOYER_LIFT_PAD: 'DetailHoyerLiftPad',
  DETAIL_WHEELCHAIR: 'DetailWheelchair',
  TRANSPORT_TYPE_ID: 'TransportTypeId',
  TRANSPORT_TYPE_NAME: 'TransportTypeName',
  PICKUP_LOCATION_TYPE: 'PickupLocationType',
  PICKUP_DOCTOR_ID: 'PickupDoctorId',
  DROPOFF_LOCATION_TYPE: 'DropoffLocationType',
  DROPOFF_DOCTOR_ID: 'DropoffDoctorId',
  IS_OUTSOURCED: 'IsOutsourced',
  OUTSOURCE_COMPANY_ID: 'OutsourceCompanyId',
  VEHICLE_ID: 'VehicleId',
  ASSIGNED_DRIVER_ID: 'AssignedDriverId',
  APPOINTMENT_DESC: 'AppointmentDesc',
  IS_RECURRING: 'IsRecurring',
  RECURRENCE_TYPE: 'RecurrenceType',
  RECURRENCE_FREQUENCY: 'RecurrenceFrequency',
  RECURRENCE_WEEK_OF_MONTH: 'RecurrenceWeekOfMonth',
  RECURRENCE_END_DATE: 'RecurrenceEndDate',
  RECURRENCE_DAYS_OF_WEEK: 'RecurrenceDaysOfWeek',
  RECURRENCE_DAY_OF_MONTH: 'RecurrenceDayOfMonth',
  TIME_ZONE_ID: 'TimeZoneId',
  OCCURRENCE_DATE: 'OccurrenceDate',
  OCCURRENCE_ID: 'OccurrenceId',
  PARENT_APPOINTMENT_DATE: 'ParentAppointmentDate',
  DATE_ADDED: 'DateAdded',
  ADDED_BY: 'AddedBy',
  REQUEST_STATUS_ID: 'RequestStatusId',
};

// Fields that must always have a non-null, non-empty value
export const FIELDS_ALWAYS_REQUIRED = [
  FIELDS.FACILITY_ID,
  FIELDS.TRANSPORT_TYPE_ID,
  FIELDS.HAS_EXISTING_APPOINTMENT,
  FIELDS.PICKUP_LOCATION_TYPE,
  FIELDS.DROPOFF_LOCATION_TYPE,
  FIELDS.AIDE_REQUIRED,
  FIELDS.UNIT_AIDE_REQUIRED,
  FIELDS.CNA_REQUIRED,
];

export const DATE_PICKER_SLOT_PROPS = {
  textField: { size: 'small', sx: { width: '100%' } },
  actionBar: { actions: ['cancel', 'accept'] },
};

export const TRIP_DIRECTION = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
};

export const TRIP_DIRECTION_NAMES = {
  [TRIP_DIRECTION.INBOUND]: 'Inbound',
  [TRIP_DIRECTION.OUTBOUND]: 'Outbound',
};

export const DETAIL_FIELDS = [
  { label: 'O2', requestField: 'detailO2', formField: FIELDS.DETAIL_O2 },
  { label: 'Snack', requestField: 'detailSnack', formField: FIELDS.DETAIL_SNACK },
  { label: 'Lunch', requestField: 'detailLunch', formField: FIELDS.DETAIL_LUNCH },
  { label: 'X-Rays', requestField: 'detailXrays', formField: FIELDS.DETAIL_XRAYS },
  { label: 'Resident Documents', requestField: 'detailResidentDocuments', formField: FIELDS.DETAIL_RESIDENT_DOCUMENTS },
  { label: 'Cushion', requestField: 'detailCushion', formField: FIELDS.DETAIL_CUSHION },
  { label: 'Hoyer Lift Pad', requestField: 'detailHoyerLiftPad', formField: FIELDS.DETAIL_HOYER_LIFT_PAD },
  { label: 'Wheelchair', requestField: 'detailWheelchair', formField: FIELDS.DETAIL_WHEELCHAIR },
];

export const TRANSPORT_ADMIN = 'Transport-Admin';
export const TRANSPORT_COORDINATOR = 'Transport-Coordinator';
export const TRANSPORT_NURSE = 'Transport-Nurse';
export const TRANSPORT_VIEW_ONLY = 'Transport-ViewOnly';

export const TIME_GRID_DAY = 'timeGridDay';
export const TIME_GRID_WEEK = 'timeGridWeek';
export const DAY_GRID_MONTH = 'dayGridMonth';
export const LIST_WEEK = 'listWeek';
